@use '@design/bapf-pattern-library/source/sass/globals' as *;

div.modal div.modal-dialog {
  max-width: 760px;
  width: auto;
}

@media (max-width: map-get($grid-breakpoints, 'sm') - 1px) {
  div.sticky-modal-footer {
    max-height: 100dvh;

    div.modal-body {
      max-height: calc(100dvh - 290px);
      overflow-y: auto;
    }

    div.modal-footer {
      position: sticky;
      padding-top: 24px;
      background-color: $color-white;
      border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
    }
  }
}
